export const state = {
  // product: undefined,
  // products: []
  pays: {},
  payss: [],
  pagination:''
}
